<template>
  <div id="Login" class="page page-login" data-view>
    <EmailForm />
    <LoginForm />
  </div>
</template>

<script>
import LoginForm from "@/components/user/UserLogin.vue"
import EmailForm from "@/components/user/UserEmail.vue"

export default {
  components: { 
    LoginForm,
    EmailForm
  },
  data () {
    return {
      onLoading: false
    }
  },
  head: {
    title: {
      inner: "Connexion",
    }
  },
  mounted () {
    
  }
}
</script>

<style lang="scss">
  @import "@/scss/helpers/mixins";
  @import "@/scss/helpers/variables";

</style>
